import React, { useEffect, useState, useRef } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import axios from "axios";
import api from "../../../utils/ApiConfig";
import { getGoogleRouteDuration } from "../../../utils/ApiConfig";
import ErrorIcon from "../../../images/fi_alert-triangle.svg";
import Logo from "../../../images/Frame 1321317892.png";
import IconAlert from "../../../images/fi_alert-circle.png";
import PDFIcon from "../../../images/pdf.png";
import DownloadIcon from "../../../images/fi_download.png";
import DemandeFo from "../../../images/demandeFournisseur.png";
import fi_calendar from "../../../images/fi_calendar.png";
import { useHistory } from "react-router-dom";
import { setHours, setMinutes } from "date-fns";
import { registerLocale } from "react-datepicker";
import { addDemandeCommandeFournisseur, parseBordereau } from "./DataService";
import { toast } from "react-toastify";
import { Form, Badge, Card, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "../../../../src/style/commande.css";
import { FormatageDate } from "../../../utilities";
import { fr } from "date-fns/locale";
import dayjs from "dayjs";
import { REACT_APP_GOOGLE_MAPS_API_KEY, getORSRouteDuration, calculatePriceFromBackend } from "../../../utils/ApiConfig.js";
import PlacesAutocompleteComponent from "../Component/PlacesAutocompleteComponent.jsx";
import { getTravelTimeFromBackend } from "../../../utils/ApiConfig"; // ou le bon chemin
import TestComment from "../../../components/TestComment";
import DerniereCommande from "../../../components/DerniereCommande";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';




const FormSupplier = () => {
  const poidsOptions = {
    "-150": "de 0 à 150kg",
    "151-300": "de 151 à 300kg",
    "301-450": "de 301 à 450kg",
    "451-600": "de 451 à 600kg",
    "601-750": "de 601 à 750kg",
    "751-900": "de 751 à 900kg",
    "901-1350": "de 901 à 1350kg"
  };
  const [isGMapsLoaded, setIsGMapsLoaded] = useState(false);
  const history = useHistory();
  const currentTimePlusOneHour = dayjs().add(1, "hour");

  // 📊 États pour le tracking des abandons
  const [premierChangement, setPremierChangement] = useState(null);
  const [nbTentativesSubmit, setNbTentativesSubmit] = useState(0);
  const [sessionId] = useState(() => Date.now()); // ID unique pour cette session
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("L'Adresse e-mail est invalide")
      .required("L'adresse e-mail est obligatoire"),
    clientName: Yup.string().required("Le nom du client est obligatoire"),
    clientPrenom: Yup.string().required("Le prénom du client est obligatoire"),
    steName: Yup.string().required(
      "Le raison social de l'entreprise est obligatoire"
    ),
    telephone: Yup.string()
      .matches(
        /^[0-9]{10}$/,
        "Le numéro de téléphone doit comporter 10 chiffres"
      )
      .required("Le numéro de téléphone est obligatoire"),
    comment: Yup.string(),
    // Vérification des adresses
    pickupAdr: Yup.string()
      .required("Adresse requise")
      .test(
        "is-selected-from-suggestions",
        "Vous devez sélectionner une adresse depuis les suggestions !",
        (value, context) => {
          const { altitude_Fournisseur, longitude_Fournisseur } = context.parent;
          return !!(altitude_Fournisseur && longitude_Fournisseur);
        }
      ),

    address: Yup.string()
      .required("Adresse requise")
      .test(
        "is-selected-from-suggestions",
        "Vous devez sélectionner une adresse depuis les suggestions !",
        (value, context) => {
          const { altitude_Livreur, longitude_Livreur } = context.parent;
          return !!(altitude_Livreur && longitude_Livreur);
        }
      ),

    steClient: Yup.string().required("Nom de l'entreprise est required"),
    poids: Yup.string()
      .oneOf(Object.keys(poidsOptions), "Veuillez sélectionner un poids valide")
      .required("Le poids de la livraison est obligatoire"),
    deliveryDateTime: Yup.date()
      .nullable()
      .when("livraisonType", {
        is: "planifiee",
        then: (schema) =>
          schema
            .required("La date de livraison est obligatoire")
            .test(
              "is-after-3h",
              "La date doit être au moins 3 heures après maintenant",
              (value) => {
                if (!value) return false;
                return dayjs(value).isAfter(dayjs().add(3, "hour"));
              }
            )
            .test(
              "is-within-valid-hours",
              "La date choisie est en dehors des heures de livraison autorisées",
              (value) => {
                if (!value) return false;
                const day = dayjs(value).day();
                const hour = dayjs(value).hour();
                const minute = dayjs(value).minute();

                if (day === 0) return false; // dimanche

                if (day === 6) {
                  // samedi : 8h30 - 12h30
                  return (
                    (hour > 8 || (hour === 8 && minute >= 30)) &&
                    (hour < 12 || (hour === 12 && minute <= 30))
                  );
                }

                // lundi à vendredi : 7h30 - 17h30
                return (
                  (hour > 7 || (hour === 7 && minute >= 30)) &&
                  (hour < 17 || (hour === 17 && minute <= 30))
                );
              }
            ),
        otherwise: (schema) => schema.nullable(),
      }),


    deliveryReceipt: Yup.mixed()
      .required("Le bordereau de livraison au format PDF est obligatoire")
      .test(
        "fileSize",
        "Fichier trop volumineux",
        (value) => value && value.size <= 5000000
      ),
  });

  // Get the current time in the timezone of France
  const franceTime = new Date().toLocaleString("fr-FR", {
    timeZone: "Europe/Paris",
  });

  // Convert to a Date object and extract the hours
  const currentHourInFrance = new Date(franceTime).getHours();
  const [poidsLabel, setPoidsLabel] = useState("Non défini");
  const [poidsSelected, setPoidsSelected] = useState(""); // State pour déclencher le recalcul
  const [poidsSupplement, setPoidsSupplement] = useState(0);
  const [tempsSupplement, setTempsSupplement] = useState(0);
  const [isSubmittingLocal, setIsSubmittingLocal] = useState(false);
  const [tarifDeBaseInitial, setTarifDeBaseInitial] = useState(19.90); // valeur par défaut
  const [tarifBase, setTarifBase] = useState(19.90);
  const [supplementLivraison, setSupplementLivraison] = useState(0);
  const [livraisonType, setLivraisonType] = useState("flex");
  const isDelay = currentHourInFrance >= 16;
  const [address, setAddress] = useState("");
  const [pickupAdr, setPickUpAdr] = useState("");
  const [file, setFile] = useState(null);
  const [Error, setError] = useState("");
  const [ErrorPickUp, setErrorPickUp] = useState("");
  const [deliveryLatLng, setDeliveryLatLng] = useState(null);
  const [pickupLatLng, setPickupLatLng] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [emailStorage, setEmailStorage] = useState(userData?.email);
  const [startDate, setStartDate] = useState(new Date());
  const [raisonSocialStorage, setRaisonSocialStorage] = useState(
    userData?.user_profil?.RaisonSocial
  );
  const [ctaErrorMessage, setCtaErrorMessage] = useState("");
  const [ctaErrorShake, setCtaErrorShake] = useState(false);
  // Contrôle PDF (bordereau)
  const [detectedWeightKg, setDetectedWeightKg] = useState(null);
  const [poidsMismatch, setPoidsMismatch] = useState(false);
  const [isPdfChecking, setIsPdfChecking] = useState(false); // analyse en cours ?
  const [pdfAnalyzed, setPdfAnalyzed] = useState(false);     // analyse terminée ?

  // Helper: retrouve la tranche à partir du kg (mêmes bornes que backend)
  const bucketFromKg = (kg) => {
    if (kg <= 150) return "-150";
    if (kg <= 300) return "151-300";
    if (kg <= 450) return "301-450";
    if (kg <= 600) return "451-600";
    if (kg <= 750) return "601-750";
    if (kg <= 900) return "751-900";
    if (kg <= 1350) return "901-1350";
    return null;
  };

    // === FLEX : jour + demi-journée
  const [flexDate, setFlexDate] = useState(new Date());   // jour choisi
  const [flexHalfDay, setFlexHalfDay] = useState(null);   // 'AM' | 'PM'
  
  // UNIQUEMENT pour FLEX
  let halfLabel = null;
  if (livraisonType === 'flex' && flexHalfDay) {
    halfLabel = (flexHalfDay === 'AM') ? 'matin' : 'après-midi';
  }
  // Retourne le 1er créneau FLEX disponible à partir de "maintenant"
  const getNextFlexSlot = () => {
    const now = dayjs();

    // Dimanche -> lundi matin
    if (now.day() === 0) {
      const monday = now.day(1).startOf('day');
      return { date: monday.toDate(), half: 'AM' };
    }

    // Samedi après 12h30 -> lundi matin
    if (now.day() === 6 && (now.hour() > 12 || (now.hour() === 12 && now.minute() >= 30))) {
      const monday = now.add(2, 'day').day(1).startOf('day');
      return { date: monday.toDate(), half: 'AM' };
    }

    // Avant 12h30 => prochain créneau = PM aujourd'hui
    if (now.hour() < 12 || (now.hour() === 12 && now.minute() <= 30)) {
      return { date: now.startOf('day').toDate(), half: 'PM' };
    }

    // Sinon => AM du lendemain (lundi si week-end)
    let next = now.add(1, 'day');
    if (next.day() === 0) next = next.add(1, 'day'); // skip dimanche
    return { date: next.startOf('day').toDate(), half: 'AM' };
  };

  // Init par défaut quand la page s’ouvre
  useEffect(() => {
    const { date, half } = getNextFlexSlot();
    setFlexDate(date);
    setFlexHalfDay(half);
  }, []);

  registerLocale("fr", fr);

  // Fonction pour bloquer les jours : dimanche et samedi après 12h
  const isDayDisabled = (date) => {
    const day = date.getDay(); // 0 = dimanche, 6 = samedi
    const hour = date.getHours();

    if (day === 0) return false; // Bloquer tout le dimanche
    if (day === 6 && hour >= 12) return false; // Bloquer samedi après 12h

    return true; // Autres jours sont valides (condition inversée car react-datepicker garde ceux pour lesquels c'est true)
  };

  // Fonction pour filtrer les heures autorisées entre 7h et 17h
  const isTimeAllowed = (time) => {
    const hour = new Date(time).getHours();
    return hour >= 7 && hour <= 17;
  };

  // Calcul de la date minimale (maintenant + 3 heures)
  const nowPlus3Hours = dayjs().add(3, 'hour').toDate();
  const [customDateError, setCustomDateError] = useState("");
  const [fileName, setFileName] = useState("");
  const [estimatedTime, setEstimatedTime] = useState(null);
  const [formikValues, setFormikValues] = useState({});
  const formikRef = useRef();
  const [totalHT, setTotalHT] = useState(0);
  const [totalTTC, setTotalTTC] = useState(0);
  const [coordonneesValides, setCoordonneesValides] = useState(false);
  const [triggerRender, setTriggerRender] = useState(false);


const HandleSave = async (values) => {
  if (isSubmittingLocal) return; // 🔒 Bloque si déjà en cours
  setIsSubmittingLocal(true);    // ⏳ Bloque l’envoi

  try {
    // Si un PDF est présent mais l'analyse n'est pas terminée → attendre
    if (formikRef.current?.values?.deliveryReceipt && !pdfAnalyzed) {
      toast.info("Analyse du bordereau en cours. Merci de patienter une seconde…");
      setIsSubmittingLocal(false);
      return;
    }

    // ✅ SUPPRIMÉ : On n'empêche plus le submit même si le poids ne correspond pas
    // L'utilisateur peut soumettre avec le poids de son choix
    let formattedDate = null;
    if (livraisonType === 'planifiee' && values.deliveryDateTime) {
      formattedDate = FormatageDate(values.deliveryDateTime);
    } else if (livraisonType === 'flex' && flexDate && flexHalfDay) {
      const base = dayjs(flexDate);
      const dt = (flexHalfDay === 'AM' ? base.hour(8).minute(0) : base.hour(13).minute(30)).toDate();
      formattedDate = FormatageDate(dt);
    }
    const userData = JSON.parse(localStorage.getItem("userData"));
    const myFormData = new FormData();
    myFormData.append("file", file);
    myFormData.append("id_fournisseur", userData.id);
    myFormData.append("adressPickUp", values.pickupAdr);
    myFormData.append("email", values.email);
    myFormData.append("adresseLivraison", values.address);
    myFormData.append("dateLivraison", formattedDate ?? '');
    myFormData.append("tel", values.telephone);
    myFormData.append("raisonSocial", values.steName);
    myFormData.append("raisonSocialClient", values.steClient);
    myFormData.append("nomClient", values.clientName);
    myFormData.append("prenomClient", values.clientPrenom);
    myFormData.append("longitudePickUp", values.altitude_Fournisseur);
    myFormData.append("altitudePickUp", values.longitude_Fournisseur);
    myFormData.append("altitudeLivraison", values.altitude_Livreur);
    myFormData.append("longitudeLivraison", values.longitude_Livreur);
    myFormData.append("commantaire", values.comment);
    myFormData.append("poids", values.poids);
    myFormData.append("poidsLabel", poidsLabel);
    myFormData.append("poidsSupplement", poidsSupplement);
    myFormData.append("estimatedTime", estimatedTime);
    myFormData.append("tempsSupplement", tempsSupplement);
    myFormData.append("tarifBase", tarifBase);
    myFormData.append("totalHT", totalHT);
    myFormData.append("totalTTC", totalTTC);
    myFormData.append("livraisonType", livraisonType);
    myFormData.append("flexHalfDay", flexHalfDay || "");   // "AM" | "PM"
    myFormData.append("flexHalfDayLabel", halfLabel || "");// "matin" | "après-midi"

    // 🔍 Ajout des données OCR pour détection de mismatch
    if (detectedWeightKg !== null) {
      myFormData.append("detectedWeightKg", detectedWeightKg);
      const detectedBucket = bucketFromKg(detectedWeightKg);
      if (detectedBucket) {
        myFormData.append("detectedBucket", detectedBucket);
      }
    }

    const response = await addDemandeCommandeFournisseur(myFormData, history);

  } catch (error) {
    console.error("Erreur lors de l'envoi de la demande :", error);
    setIsSubmittingLocal(false); // ✅ Débloque en cas d’échec
  }
};


  const searchOptions = {
    componentRestrictions: { country: ["fr", "mc"] },
    types: ["geocode", "establishment"],
  };

  const logout = () => {
    // Preserve remembered email before clearing localStorage
    const rememberedEmail = localStorage.getItem("rememberedEmail");

    localStorage.clear();

    // Restore remembered email if it existed
    if (rememberedEmail) {
      localStorage.setItem("rememberedEmail", rememberedEmail);
    }

    window.location.href = "/login";
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const values = formikRef.current?.values;
      const complet = !!(values &&
        values.pickupAdr &&
        values.address &&
        values.poids &&
        values.altitude_Fournisseur &&
        values.longitude_Fournisseur &&
        values.altitude_Livreur &&
        values.longitude_Livreur);

      setTriggerRender(complet); // met à jour l'état local
    }, 500); // vérifie toutes les 500ms

    return () => clearInterval(interval);
  }, [file]);

  useEffect(() => {
    if (!window.google) {
      const gmapScriptEl = document.createElement("script");
      gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      gmapScriptEl.async = true;
      gmapScriptEl.defer = true;
      gmapScriptEl.onload = () => setIsGMapsLoaded(true);
      document.body.appendChild(gmapScriptEl);
    } else {
      setIsGMapsLoaded(true);
    }
  }, []);

  useEffect(() => {
  }, [emailStorage, raisonSocialStorage]);

  // 📊 Fonction pour envoyer le tracking d'abandon
  const trackFormAbandonment = async (raison, erreurs = null) => {
    const values = formikRef.current?.values;
    if (!values || !userData?.id) return;

    const tempsRemplissage = premierChangement
      ? Math.floor((Date.now() - premierChangement) / 1000)
      : null;

    // Vérifier si TOUS les champs obligatoires sont remplis
    const formulaireRellementComplet = !!(
      values.pickupAdr &&
      values.address &&
      values.poids &&
      values.clientName &&
      values.clientPrenom &&
      values.steClient &&
      values.telephone &&
      values.email &&
      values.deliveryReceipt &&
      values.altitude_Fournisseur &&
      values.longitude_Fournisseur &&
      values.altitude_Livreur &&
      values.longitude_Livreur
    );

    try {
      await api.post('/fo/form-abandonment', {
        id_fournisseur: userData.id,
        adresse_ramassage: values.pickupAdr || null,
        adresse_livraison: values.address || null,
        poids: values.poids || null,
        type_livraison: livraisonType || null,
        prix_calcule_ht: totalHT || null,
        prix_calcule_ttc: totalTTC || null,
        formulaire_complet: formulaireRellementComplet,
        temps_remplissage_secondes: tempsRemplissage,
        raison_abandon: raison,
        erreurs_validation: erreurs ? JSON.stringify(erreurs) : null,
        tentatives_submit: nbTentativesSubmit,
      });
    } catch (error) {
      console.error('Erreur tracking abandon:', error);
    }
  };

  // 📊 Tracker quand l'utilisateur quitte la page sans soumettre
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Si le formulaire a été rempli mais pas soumis
      if (triggerRender && !isSubmittingLocal) {
        trackFormAbandonment('quitte_page');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [triggerRender, isSubmittingLocal, premierChangement, nbTentativesSubmit]);

  // 📊 Enregistrer le premier changement dans le formulaire
  useEffect(() => {
    const interval = setInterval(() => {
      const values = formikRef.current?.values;
      const aUnChamp = values && (
        values.pickupAdr ||
        values.address ||
        values.poids ||
        values.clientName ||
        values.clientPrenom
      );

      if (aUnChamp && !premierChangement) {
        setPremierChangement(Date.now());
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [premierChangement]);

  // ✅ Nouveau useEffect qui appelle le backend pour calculer les prix
  useEffect(() => {
    const calculatePrices = async () => {
      // Vérifier que tous les paramètres nécessaires sont présents
      if (!userData?.id || !poidsSelected || !estimatedTime || !livraisonType) {
        return;
      }

      // Appeler le backend pour calculer les prix
      const priceData = await calculatePriceFromBackend(
        userData.id,
        poidsSelected,
        estimatedTime,
        livraisonType
      );

      if (priceData) {
        // Mettre à jour tous les états avec les valeurs calculées côté backend
        setTarifBase(priceData.tarifBase);
        setPoidsSupplement(priceData.poidsSupplement);
        setTempsSupplement(priceData.tempsSupplement);
        setSupplementLivraison(priceData.supplementLivraison);
        setTotalHT(priceData.totalHT);
        setTotalTTC(priceData.totalTTC);
      }
    };

    calculatePrices();
  }, [
    userData?.id,
    poidsSelected,
    estimatedTime,
    livraisonType
  ]);

useEffect(() => {
  const values = formikRef.current?.values;
  const hasAllCoordinates =
    values?.longitude_Fournisseur &&
    values?.altitude_Fournisseur &&
    values?.longitude_Livreur &&
    values?.altitude_Livreur;

  if (hasAllCoordinates && coordonneesValides) {
    const origin = {
      lat: values.altitude_Fournisseur,
      lng: values.longitude_Fournisseur,
    };
    const destination = {
      lat: values.altitude_Livreur,
      lng: values.longitude_Livreur,
    };

    // 🕒 Calcul intelligent de l'heure de départ selon le type
    let departureTime = new Date();
        // ➜ FLEX : utiliser la date + demi-journée choisies
    if (livraisonType === "flex" && typeof flexDate !== "undefined" && typeof flexHalfDay !== "undefined" && flexDate && flexHalfDay) {
      const base = dayjs(flexDate); // début du jour choisi

      if (flexHalfDay === "AM") {
        // Samedi matin commence à 9h, sinon 8h
        const startHour = base.day() === 6 ? 9 : 8;
        departureTime = base.hour(startHour).minute(0).toDate();
      } else {
        // Après-midi à 13h30
        departureTime = base.hour(13).minute(30).toDate();
      }

      // Sécurité : si l’utilisateur est sur aujourd’hui ET la demi-journée en cours,
      // on bascule automatiquement sur le prochain slot dispo
      const now = dayjs();
      if (base.isSame(now, 'day')) {
        const amEnCours = (now.hour() < 12 || (now.hour() === 12 && now.minute() < 30));
        const pmEnCours = (now.hour() >= 13 && (now.hour() < 17 || (now.hour() === 17 && now.minute() <= 30)));
        if ((flexHalfDay === 'AM' && amEnCours) || (flexHalfDay === 'PM' && pmEnCours)) {
          // prochain slot Flex (même logique que ton helper)
          let next = now;
          if (pmEnCours) next = next.add(1, 'day');
          // dimanche => lundi
          if (next.day() === 0) next = next.add(1, 'day');
          const isSamedi = next.day() === 6;
          const h = isSamedi ? 9 : 8;
          departureTime = next.startOf('day').hour(h).minute(0).toDate();
        }
      }
    }
    // ➜ ensuite, ton ancien "if (planifiee) ..." devient "else if (planifiee) ..."

    else if (livraisonType === "planifiee" && values.deliveryDateTime) {
      departureTime = dayjs(values.deliveryDateTime).subtract(1, "hour").toDate();

    } else if (livraisonType === "urgent") {
      departureTime = dayjs().add(30, "minute").toDate();
    } else {
      const now = dayjs();
      const hour = now.hour();

      if (hour < 12) {
        departureTime = now.hour(13).minute(30).toDate();
      } else {
        let nextDay = now.add(1, "day").hour(8).minute(0);
        // Si le jour suivant est samedi (6) ou dimanche (0)
        while (nextDay.day() === 0 || nextDay.day() === 6) {
          nextDay = nextDay.add(1, "day");
        }
        departureTime = nextDay.toDate();
      }
    }

    console.log("🧭 Appel API backend avec :", {
      origin,
      destination,
      departureTime,
    });

    
    getTravelTimeFromBackend(origin, destination, departureTime)
      .then((minutes) => {
        if (!minutes || isNaN(minutes)) {
          setEstimatedTime("indisponible");
        } else {
          setEstimatedTime(minutes);
        }
        setCoordonneesValides(false);
      })
      .catch((err) => {
        console.error("Erreur de calcul du temps de trajet :", err);
        setEstimatedTime("indisponible");
        setCoordonneesValides(false);
      });
  }
}, [
  coordonneesValides,
  formikRef.current?.values?.longitude_Fournisseur,
  formikRef.current?.values?.altitude_Fournisseur,
  formikRef.current?.values?.longitude_Livreur,
  formikRef.current?.values?.altitude_Livreur,
]);
useEffect(() => {
  const values = formikRef.current?.values;
  const hasAllCoordinates =
    values?.longitude_Fournisseur &&
    values?.altitude_Fournisseur &&
    values?.longitude_Livreur &&
    values?.altitude_Livreur;

  if (!hasAllCoordinates) return;

  const origin = {
    lat: values.altitude_Fournisseur,
    lng: values.longitude_Fournisseur,
  };
  const destination = {
    lat: values.altitude_Livreur,
    lng: values.longitude_Livreur,
  };

  // 🧠 Logique métier pour calcul du départ
  let departureTime = new Date();
  const now = dayjs();
  // ➜ FLEX : utiliser la date + demi-journée choisies
  if (livraisonType === "flex" && typeof flexDate !== "undefined" && typeof flexHalfDay !== "undefined" && flexDate && flexHalfDay) {
    const base = dayjs(flexDate);

    if (flexHalfDay === "AM") {
      const startHour = base.day() === 6 ? 9 : 8;
      departureTime = base.hour(startHour).minute(0).toDate();
    } else {
      departureTime = base.hour(13).minute(30).toDate();
    }

    const amEnCours = (base.isSame(now, 'day') && (now.hour() < 12 || (now.hour() === 12 && now.minute() < 30)));
    const pmEnCours = (base.isSame(now, 'day') && (now.hour() >= 13 && (now.hour() < 17 || (now.hour() === 17 && now.minute() <= 30))));
    if ((flexHalfDay === 'AM' && amEnCours) || (flexHalfDay === 'PM' && pmEnCours)) {
      let next = now;
      if (pmEnCours) next = next.add(1, 'day');
      if (next.day() === 0) next = next.add(1, 'day');
      const isSamedi = next.day() === 6;
      const h = isSamedi ? 9 : 8;
      departureTime = next.startOf('day').hour(h).minute(0).toDate();
    }
  }

  else if (livraisonType === "planifiee" && values.deliveryDateTime) {
    departureTime = dayjs(values.deliveryDateTime).subtract(1, "hour").toDate();
  } else if (livraisonType === "urgent") {
    const hour = now.hour();
    const minute = now.minute();

    // V2: Si après 18h15 => lendemain matin
    if (hour > 18 || (hour === 18 && minute >= 15)) {
      departureTime = now.add(1, 'day').hour(8).minute(0).toDate();
      // dimanche ou samedi => lundi
      if (departureTime.getDay() === 0 || departureTime.getDay() === 6) {
        departureTime = dayjs(departureTime).day(1).hour(8).minute(0).toDate();
      }
    } else {
      departureTime = now.add(30, "minute").toDate();
    }
  } else {
    const hour = now.hour();

    if (hour < 12) {
      departureTime = now.hour(13).minute(30).toDate();
    } else {
      departureTime = now.add(1, "day").hour(8).minute(0).toDate();
      if (departureTime.getDay() === 0 || departureTime.getDay() === 6) {
        departureTime = dayjs(departureTime).day(1).hour(8).minute(0).toDate();
      }
    }
  }

  console.log("🕒 Nouveau calcul avec departureTime:", departureTime);

  getTravelTimeFromBackend(origin, destination, departureTime)
    .then((minutes) => {
      if (!minutes || isNaN(minutes)) {
        setEstimatedTime("indisponible");
      } else {
        setEstimatedTime(minutes);
      }
    })
    .catch((err) => {
      console.error("Erreur API backend :", err);
      setEstimatedTime("indisponible");
    });
}, [livraisonType, formikRef.current?.values?.deliveryDateTime]);

useEffect(() => {
  const values = formikRef.current?.values;

  const hasAllCoordinates =
    values?.longitude_Fournisseur &&
    values?.altitude_Fournisseur &&
    values?.longitude_Livreur &&
    values?.altitude_Livreur;

  const deliveryDateTime = values?.deliveryDateTime;

  if (
    livraisonType === "planifiee" &&
    deliveryDateTime &&
    hasAllCoordinates
  ) {
    const origin = {
      lat: values.altitude_Fournisseur,
      lng: values.longitude_Fournisseur,
    };
    const destination = {
      lat: values.altitude_Livreur,
      lng: values.longitude_Livreur,
    };

    const departureTime = dayjs(deliveryDateTime).subtract(1, "hour").toDate();

    getTravelTimeFromBackend(origin, destination, departureTime).then((minutes) => {
      setEstimatedTime(minutes);
    });
  }
}, [
  livraisonType,
  formikRef.current?.values?.deliveryDateTime,
  formikRef.current?.values?.longitude_Fournisseur,
  formikRef.current?.values?.altitude_Fournisseur,
  formikRef.current?.values?.longitude_Livreur,
  formikRef.current?.values?.altitude_Livreur,
]);


  // ❌ REMOVED: Frontend time supplement calculation
  // This calculation is now handled exclusively by the backend via calculatePriceFromBackend()
  // The tempsSupplement value is updated directly by the backend API at lines 479-514

  // ❌ REMOVED: Frontend HT and TTC totals calculation
  // These calculations are now handled exclusively by the backend via calculatePriceFromBackend()
  // The totalHT and totalTTC values are updated directly by the backend API at lines 479-514

  // ❌ Ancienne logique : récupération du tarif de base côté frontend (SUPPRIMÉE)
  // Maintenant géré par le backend via calculatePriceFromBackend()
  const location = useLocation();

  const formulaireComplet = () => {
    const values = formikRef.current?.values;
    return (
      values?.pickupAdr &&
      values?.address &&
      values?.poids &&
      values?.clientName &&
      values?.clientPrenom &&
      values?.steClient &&
      values?.telephone &&
      values?.email &&
      values?.deliveryReceipt &&
      values?.altitude_Fournisseur &&
      values?.longitude_Fournisseur &&
      values?.altitude_Livreur &&
      values?.longitude_Livreur
    );
  };
  const touchAllFields = (values) => {
    Object.keys(values).forEach((field) => {
      formikRef.current.setFieldTouched(field, true, true);
    });
  };

  return (
    <>
      <div className="PageFournisseur">
        <div className="header row headerSection">
          <div className="col-md-6">
            {" "}
            <img src={Logo} alt="logo marion" width="100px" />
          </div>
            <div className="col-md-6 d-flex justify-content-end align-items-center gap-3">
              <Link
                to="/fournisseur/commande"
                className={`btn btn-custom-menu ${location.pathname === "/fournisseur/commande" ? "active" : ""}`}
              >
                📋 Nouvelle livraison
              </Link>

              <Link
                to="/fournisseur/mes-livraisons"
                className={`btn btn-custom-menu ${location.pathname === "/fournisseur/mes-livraisons" ? "active" : ""}`}
              >
                🛻 Historique des livraisons
              </Link>
              <button onClick={logout} className="btn logoutBtn">
                Se déconnecter
              </button>
            </div>
        </div>
	<DerniereCommande idFournisseur={userData.id} />
        <Row className="contenaire">
          <Col md="8" order={1} className="right-side mainBgColor">
            <h4 className="pt-5 title-style">Commande fournisseur</h4>
            <Alert severity="info" variant="filled">
                      <AlertTitle>Information</AlertTitle>
                      Marion accepte les livraisons du lundi au vendredi de 8h à 17h
                et le samedi de 9h à 12h. Passé ce délai, les commandes seront
                traitées le prochain jour ouvrable.
            </Alert><br></br>
            {/*  
            <Row className="layout alert-message">
              <Col xs="auto">
                <img src={IconAlert} alt="Alert Icon" className="iconAlert" />
              </Col>
              <Col className="text-container colorBlue">
                Marion accepte les livraisons du lundi au vendredi de 8h à 17h
                et le samedi de 9h à 12h. Passé ce délai, les commandes seront
                traitées le prochain jour ouvrable.
              </Col>
            </Row>*/}
            <Formik
              innerRef={formikRef}
              initialValues={{
                email: emailStorage,
                clientName: "",
                clientPrenom: "",
                steName: raisonSocialStorage,
                steClient: "",
                telephone: "",
                comment: "",
                deliveryDateTime: "",
                deliveryReceipt: "",
                pickupAdr: "",
                altitude_Fournisseur: "",
                longitude_Fournisseur: "",
                address: "",
                altitude_Livreur: "",
                longitude_Livreur: "",
                livraisonType: "flex",
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                HandleSave(values);
              }}
            >
              {({
                errors,
                touched,
                setFieldValue,
                isInvalid,
                isSubmitting,
                handleSubmit,
                handleBlur,
                values,
                setFieldError,
                setFieldTouched,
                isValid,
                dirty,
              }) => {
                return (
                  <Form onSubmit={handleSubmit} id="formikForm" className="mt-40">
                    <Card className="mb-3 cardDemandeFo">
                      <Card.Body>
                        <Card.Title className="pb-3 colorTitle textCard">
                          1. Informations fournisseurs
                        </Card.Title>
                        <Row>
                          <Col>
              
                            <div className="form-floating mb-3">
                              <Field
                                type="email"
                                name="email"
                                className="form-control backWhite"
                                id="floatingInputemail"
                                placeholder=""
                                value={values?.email || emailStorage}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setEmailStorage(value);
                                  setFieldValue("email", value);
                                }}
                              />
                              <label
                                htmlFor="floatingInputemail"
                                className="colorInput"
                              >
                                Adresse e-mail
                              </label>
                              {touched.email && errors.email && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.email}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col>
                            <div className="form-floating mb-3">
                              <Field
                                type="text"
                                name="steName"
                                className={`form-control backWhite ${touched.steName && errors.steName
                                  ? "danger-input"
                                  : ""
                                  }`}
                                id="floatingInputsteName"
                                placeholder=""
                                value={values?.steName || raisonSocialStorage}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setRaisonSocialStorage(value);
                                  setFieldValue("steName", value);
                                }}
                              />
                              <label
                                htmlFor="floatingInputsteName"
                                className="colorInput"
                              >
                                Nom de l'entreprise
                              </label>
                              {touched.steName && errors.steName && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.steName}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-3 cardDemandeFo">
                      <Card.Body>
                        <Card.Title className="pb-3 colorTitle textCard">
                          2. Informations livraison
                        </Card.Title>
                        {isGMapsLoaded && (
                          <Row>
                            <Col>
                            <label htmlFor="pickupAdr">Adresse de ramassage</label>
                              <div className="form-floating mb-3">
                                
                                <PlacesAutocompleteComponent
                                  name="pickupAdr"
                                  onAdresseSelected={() => setCoordonneesValides(true)}
                                  value={values.pickupAdr}
                                  className="backWhite"
                                  setFieldValue={setFieldValue}
                                  searchOptions={searchOptions}
                                  setFieldTouched={setFieldTouched}
                                  handleFieldBlur={() => handleBlur("pickupAdr")}
                                  setFieldError={setFieldError}
                                  isInvalid={
                                    touched.pickupAdr && !!errors.pickupAdr
                                  }
                                />
                                <ErrorMessage
                                  name="pickupAdr"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>

                            <Col>
                            <label htmlFor="address">Adresse de livraison</label>
                              <Form.Group
                                className="mb-3"
                                controlId="formAddress"
                              >
                                <PlacesAutocompleteComponent
                                  name="address"
                                  onAdresseSelected={() => setCoordonneesValides(true)}
                                  value={values.address}
                                  className="backWhite"
                                  setFieldValue={setFieldValue}
                                  searchOptions={searchOptions}
                                  setFieldTouched={setFieldTouched}
                                  handleFieldBlur={() => handleBlur("address")}
                                  setFieldError={setFieldError}
                                  isInvalid={
                                    touched.address && !!errors.address
                                  }
                                />
                                <ErrorMessage
                                  name="address"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <div className="form-floating">
                              <Field
                                as="select"
                                name="poids"

                                id="floatingPoids"
                                className={`form-control backWhite ${touched.poids && errors.poids ? "danger-input" : ""}`}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setFieldValue("poids", val);
                                  setPoidsLabel(poidsOptions[val] || "Non défini");
                                  setPoidsSelected(val); // ✅ Déclenche le recalcul des prix via useEffect

                                  // 🔁 Recalcule le mismatch si un poids a été détecté
                                  if (detectedWeightKg !== null) {
                                    const suggested = bucketFromKg(detectedWeightKg);
                                    const hasMismatch = !!suggested && suggested !== val;
                                    setPoidsMismatch(hasMismatch);

                                    // Afficher un toast d'avertissement si différence détectée
                                    if (hasMismatch && val) {
                                      toast.warning(
                                        `Le poids détecté dans le bordereau (${detectedWeightKg} kg) ne correspond pas à la tranche sélectionnée. Tranche suggérée : ${poidsOptions[suggested]}`
                                      );
                                    }
                                  } else {
                                    // Si aucun poids détecté, on n'empêche pas le submit
                                    setPoidsMismatch(false);
                                  }
                                }}

                              >
                                <option value="">Poids livraison (en kilos)</option>
                                <option value="-150">- de 150 kilos</option>
                                <option value="151-300">151 à 300 Kg</option>
                                <option value="301-450">301 à 450 Kg</option>
                                <option value="451-600">451 à 600 Kg</option>
                                <option value="601-750">601 à 750 Kg</option>
                                <option value="751-900">751 à 900 Kg</option>
                                <option value="901-1350">901 à 1350 Kg</option>
                              </Field>
                              <label htmlFor="floatingPoids" className="colorInput">Poids livraison (en kilos)</label>
                              <ErrorMessage name="poids" component="div" className="text-danger" />
                            </div>
                          </Col>
                          <Col>
                           <TestComment />  
			</Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-3 cardDemandeFo">
                      <Card.Body>
                        <Card.Title className="pb-3 colorTitle textCard">
                          3. Heure de livraison
                        </Card.Title>
                        <Row className="mb-3">
                          <Col md={4}>
                            <label className={`livraison-box flex ${values.livraisonType === 'flex' ? 'selected' : ''}`}>
                              <input
                                type="radio"
                                name="livraisonType"
                                value="flex"
                                checked={values.livraisonType === 'flex'}
                                onChange={() => {
                                  setFieldValue("livraisonType", "flex");
                                  setLivraisonType("flex");
                                  const { date, half } = getNextFlexSlot(); // réinit au 1er créneau dispo
                                  setFlexDate(date);
                                  setFlexHalfDay(half);
                                }}
                              />
                              <strong>Flex  </strong>
                              <span className="badge bg-success">Demi-journée suivante</span>
                              <p className="small">
                                ⏳ Livraison sous la demi-journée, heure choisie par nous.
                              </p>
                            </label>

                            {/* UI FLEX : jour + demi-journée */}
                            {values.livraisonType === "flex" && (
                              <div className="mt-2">

                                {/* Jour uniquement (dimanche bloqué) — avec label inside input */}
                                <div className="form-floating mt-2">
                                  <DatePicker
                                    id="flexDeliveryDate"
                                    selected={flexDate}
                                    onChange={(d) => {
                                      const chosen = dayjs(d || new Date()).startOf('day');
                                      // si dimanche -> passer au lundi
                                      const safe = chosen.day() === 0 ? chosen.add(1, 'day') : chosen;

                                      // samedi : PM indisponible
                                      const isSaturday = safe.day() === 6;
                                      let half = flexHalfDay;

                                      // Si le jour choisi est aujourd’hui, on interdit la demi-journée en cours
                                      const now = dayjs();
                                      const isToday = safe.isSame(now, 'day');

                                      if (isSaturday && half === 'PM') half = 'AM';

                                      if (isToday) {
                                        const morningOngoing = (now.hour() < 12 || (now.hour() === 12 && now.minute() < 30));
                                        if (morningOngoing && half === 'AM') half = 'PM';

                                        const afternoonOngoing = (now.hour() >= 13 && (now.hour() < 17 || (now.hour() === 17 && now.minute() <= 30)));
                                        if (afternoonOngoing) {
                                          // PM en cours → passer au prochain slot auto
                                          const { date, half: nextHalf } = getNextFlexSlot();
                                          setFlexDate(date);
                                          setFlexHalfDay(nextHalf);
                                          return;
                                        }
                                      }

                                      setFlexDate(safe.toDate());
                                      setFlexHalfDay(half || 'AM');
                                    }}
                                    locale="fr"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    filterDate={(date) => dayjs(date).day() !== 0} // dimanche OFF
                                    className="form-control custom-datepicker"
                                    placeholderText=" " // requis pour l’effet floating
                                  />
                                  <label htmlFor="flexDeliveryDate" className="colorInput">
                                    Date et Heure de livraison
                                  </label>
                                </div>

                                {/* Radios Matin / Après-midi avec désactivation dynamique */}
                                <div className="mt-2 p-2 rounded border">
                                  {(() => {
                                    const d = dayjs(flexDate);
                                    const now = dayjs();
                                    const isToday = d.isSame(now, 'day');
                                    const isSaturday = d.day() === 6;

                                    // demi-journées "en cours" aujourd’hui
                                    const amOngoing = isToday && (now.hour() < 12 || (now.hour() === 12 && now.minute() < 30));
                                    const pmOngoing = isToday && (now.hour() >= 13 && (now.hour() < 17 || (now.hour() === 17 && now.minute() <= 30)));

                                    const AMdisabled = isToday; // matin indisponible le jour même
                                    const PMdisabled = ((isToday && (now.hour() > 12 || (now.hour() === 12 && now.minute() >= 31))) || isSaturday);

                                    return (
                                      <>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="flexAM"
                                            name="flexHalfDay"
                                            value="AM"
                                            checked={flexHalfDay === 'AM'}
                                            disabled={AMdisabled}
                                            onChange={() => setFlexHalfDay('AM')}
                                          />
                                          <label className="form-check-label" htmlFor="flexAM">
                                            Matin (7h – 12h){isSaturday ? " — samedi matin seulement" : ""}
                                          </label>
                                        </div>

                                        <div className="form-check mt-1">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="flexPM"
                                            name="flexHalfDay"
                                            value="PM"
                                            checked={flexHalfDay === 'PM'}
                                            disabled={PMdisabled}
                                            onChange={() => setFlexHalfDay('PM')}
                                          />
                                          <label className="form-check-label" htmlFor="flexPM">
                                            Après-midi (13h – 17h)
                                          </label>
                                        </div>

                                        {isToday && AMdisabled && PMdisabled && (
                                          <div className="mt-2 small text-muted">
                                            Aucun créneau disponible aujourd’hui, choisissez le prochain jour ouvré.
                                          </div>
                                        )}
                                      </>
                                    );
                                  })()}
                                </div>
                              </div>
                            )}
                          </Col>


                          <Col md={4}>
                            <label className={`livraison-box planifiee  ${values.livraisonType === 'planifiee' ? 'selected' : ''}`}>
                              <input
                                type="radio"
                                name="livraisonType"
                                value="planifiee"
                                checked={values.livraisonType === 'planifiee'}
                                onChange={() => { setFieldValue("livraisonType", "planifiee"); setLivraisonType("planifiee"); }}
                              />
                              <strong>Planifiée (+9,90 €)  </strong>
                              <span className="badge bg-info">Dès H+3</span>
                              <p className="small">📅 Choisis ton jour et créneau horaire.</p>
                            </label>
                            {values.livraisonType === "planifiee" && (
                              <div className="form-floating mt-2">
                                <DatePicker
                                  selected={startDate}
                                  onChange={(date) => {
                                    const nowPlus3 = dayjs().add(3, "hour");

                                    if (dayjs(date).isBefore(nowPlus3)) {
                                      setCustomDateError("Merci de choisir une date au moins 3 heures après l'heure actuelle.");
                                    } else {
                                      setCustomDateError("");
                                    }

                                    setStartDate(date);
                                    setFieldValue("deliveryDateTime", date);
                                    setCoordonneesValides(true);
                                  }}
                                  locale="fr"
                                  showTimeSelect
                                  dateFormat="dd/MM/yyyy HH:mm"
                                  minDate={nowPlus3Hours}
                                  filterDate={(date) => {
                                    const day = date.getDay();
                                    return day !== 0; // Dimanche OFF
                                  }}
                                  filterTime={(time) => {
                                    const date = new Date(time);
                                    const day = date.getDay();
                                    const hour = date.getHours();
                                    const minute = date.getMinutes();
                                    if (day >= 1 && day <= 5) {
                                      // Lundi à Vendredi : 7h30 - 17h30
                                      return (
                                        (hour > 7 || (hour === 7 && minute >= 30)) &&
                                        (hour < 17 || (hour === 17 && minute <= 30))
                                      );
                                    }
                                    if (day === 6) {
                                      // Samedi : 8h30 - 12h30
                                      return (
                                        (hour > 8 || (hour === 8 && minute >= 30)) &&
                                        (hour < 12 || (hour === 12 && minute <= 30))
                                      );
                                    }

                                    return false; // Dimanche : bloqué
                                  }}
                                  className="form-control custom-datepicker"
                                />
                                <label htmlFor="floatingDeliveryDateTime" className="colorInput">
                                  Date et Heure de livraison
                                </label>
                                <ErrorMessage name="deliveryDateTime" component="div" className="text-danger" />
                                {customDateError && (
                                    <div className="text-danger mt-2">
                                      <small>{customDateError}</small>
                                    </div>
                                  )}
                              </div>
                            )}
                          </Col>
                          <Col md={4}>
                            <label className={`livraison-box urgent ${values.livraisonType === 'urgent' ? 'selected' : ''}`}>
                              <input
                                type="radio"
                                name="livraisonType"
                                value="urgent"
                                checked={values.livraisonType === 'urgent'}
                                onChange={() => { setFieldValue("livraisonType", "urgent"); setLivraisonType("urgent"); }}
                              />
                              <strong>Urgent (+19,90 €)   </strong>
                              <span className="badge bg-danger">Service express</span>
                              <p className="small">🚀 Marion vient récupérer la commande dans l'heure.</p>
                            </label>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-3 cardDemandeFo">
                      <Card.Body>
                        <Card.Title className="pb-3 colorTitle textCard">
                          4. Informations client à livrer
                        </Card.Title>
                        <Row>
                          <Col>
                            <div className="form-floating mb-3">
                              <Field
                                type="text"
                                name="steClient"
                                className={`form-control backWhite ${touched.steClient && errors.steClient
                                  ? "danger-input"
                                  : ""
                                  }`}
                                id="floatingInputsteClient"
                                placeholder=""
                              />
                              <label
                                htmlFor="floatingInputsteClient"
                                className="colorInput"
                              >
                                Nom de l'entreprise
                              </label>
                              {touched.steClient && errors.steClient && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.steClient}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col>
                            <div className="form-floating mb-3">
                              <Field
                                type="text"
                                name="clientName"
                                className={`form-control backWhite ${touched.clientName && errors.clientName
                                  ? "danger-input"
                                  : ""
                                  }`}
                                id="floatingInputClientName"
                                placeholder=""
                              />
                              <label
                                htmlFor="floatingInputClientName"
                                className="colorInput"
                              >
                                Nom client
                              </label>
                              {touched.clientName && errors.clientName && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.clientName}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="form-floating mb-3">
                              <Field
                                type="text"
                                name="clientPrenom"
                                className={`form-control backWhite ${touched.clientPrenom && errors.clientPrenom
                                  ? "danger-input"
                                  : ""
                                  }`}
                                id="floatingInputclientPrenom"
                                placeholder=""
                              />
                              <label
                                htmlFor="floatingInputclientPrenom"
                                className="colorInput"
                              >
                                Prénom client
                              </label>
                              {touched.clientPrenom && errors.clientPrenom && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.clientPrenom}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col>
                            <div className="form-floating mb-3">
                              <Field
                                type="text"
                                name="telephone"
                                className={`form-control backWhite ${touched.telephone && errors.telephone
                                  ? "danger-input"
                                  : ""
                                  }`}
                                id="floatingTelephone"
                                placeholder=""
                              />
                              <label
                                htmlFor="floatingTelephone"
                                className="colorInput"
                              >
                                Téléphone portable
                              </label>
                              {touched.telephone && errors.telephone && (
                                <div className="text-start mt-8 d-flex">
                                  <img
                                    src={ErrorIcon}
                                    className="mr-8"
                                    alt="error icon"
                                  />
                                  <span className="text-danger">
                                    {errors.telephone}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card className="mb-3 cardDemandeFo">
                      <Card.Body>
                        <Row>
                          <div>
                            <div className="file-input-container">
                              <div className="file-info">
                                <img
                                  src={PDFIcon}
                                  alt="file icon"
                                  className="file-icon"
                                />
                                <div className="file-details">
                                  <strong className="file-Title">
                                    Bordereau de livraison
                                  </strong>
                                  <p>Fichier autorisé : PDF, max. 5 MO</p>
                                  {fileName && (
                                    <p className="uploaded-file-name">
                                      Fichier téléchargé : {fileName}
                                    </p>
                                  )}
                                 <ErrorMessage
                                  name="file"
                                  component="p"
                                  className="text-red-500 mt-1"
                                /> 
                                </div>
                              </div>
                              <label
                                htmlFor="file"
                                className="file-upload-button backWhite"
                              >
                                <img src={DownloadIcon} alt="download icon" />
                                Ajouter le bordereau
                              </label>
                              <input
                                id="file"
                                name="deliveryReceipt"
                                accept=".pdf"
                                type="file"
                                onChange={async (event) => {
                                  const f = event.currentTarget.files[0];

                                  // Réinitialise les états d'analyse
                                  setDetectedWeightKg(null);
                                  setPoidsMismatch(false);
                                  setPdfAnalyzed(false);

                                  // Pas de fichier → pas d'analyse, on autorise le submit
                                   if (!f) {
                                    setFieldValue("deliveryReceipt", null);
                                    setFile(null);
                                    setFileName("");
                                    return;
                                  }

                                  // ✅ Vérification immédiate avant tout traitement
                                  if (f.size > 5 * 1024 * 1024) {
                                    toast.error("La taille du fichier ne doit pas dépasser 5 Mo");
                                    setFieldError("deliveryReceipt", "La taille du fichier ne doit pas dépasser 5 Mo");
                                    setFieldValue("deliveryReceipt", null);
                                    setFile(null);
                                    setFileName("");
                                    return;
                                  } 

                                  if (f.type !== "application/pdf") {
                                    toast.error("Seuls les fichiers PDF sont autorisés");
                                    setFieldError("deliveryReceipt", "Seuls les fichiers PDF sont autorisés");
                                    setFieldValue("deliveryReceipt", null);
                                    setFile(null);
                                    setFileName("");
                                    return;
                                  }

                                  // ✅ Si OK → set valeurs
                                  setFieldValue("deliveryReceipt", f);
                                  setFile(f);
                                  setFileName(f ? f.name : "");

                                  try {
                                    setIsPdfChecking(true);
                                    const res = await parseBordereau(f); // ⇦ appel API backend

                                    setPdfAnalyzed(true);
                                    setIsPdfChecking(false);

                                    if (res?.ok && res?.poids_total_kg) {
                                      const kg = res.poids_total_kg;
                                      setDetectedWeightKg(kg);

                                      const suggested = bucketFromKg(kg);

                                      // Hors grille connue (> 1350 kg)
                                      if (!suggested) {
                                        setPoidsMismatch(false); // on autorise le submit
                                        const msg = `Poids détecté dans le bordereau : ${kg} kg. Si ce n'est pas exact, indique le poids réel pour valider ta commande ; au-delà de 1350 kg, merci de nous contacter.`;
                                        toast.info(msg);
                                        return;
                                      }

                                      // Si pas de poids choisi → auto-sélectionner la bonne tranche
                                      if (!formikRef.current?.values?.poids) {
                                        setFieldValue("poids", suggested);
                                        setPoidsLabel(poidsOptions[suggested]);
                                        setPoidsSelected(suggested); // ✅ Déclenche le recalcul des prix
                                        setPoidsMismatch(false);
                                        toast.info(`Poids détecté ${kg} kg. Tranche sélectionnée : ${poidsOptions[suggested]}`);
                                        return;
                                      }

                                      // Si la tranche choisie ≠ tranche détectée → mismatch (⚠️ mais on n'empêche plus le submit)
                                      if (formikRef.current.values.poids !== suggested) {
                                        setPoidsMismatch(false);
                                        const msg = `Poids détecté ${kg} kg. Tranche suggérée : ${poidsOptions[suggested]}.`;
                                        toast.info(msg);
                                      } else {
                                        setPoidsMismatch(false); // OK
                                      }
                                    } else {
                                      // ⚠️ Poids non trouvé : on autorise le submit
                                      setDetectedWeightKg(null);
                                      setPoidsMismatch(false);
                                      toast.info("Bordereau bien transmis");
                                    }
                                  } catch (e) {
                                    console.error(e);
                                    // ⚠️ Erreur d'analyse : on autorise le submit
                                    setDetectedWeightKg(null);
                                    setPoidsMismatch(false);
                                    setPdfAnalyzed(true);
                                    setIsPdfChecking(false);
                                    toast.info("Bordereau bien transmis");
                                  }
                                }}

                                className="file-input"
                              />
                            </div>
                            {touched.deliveryReceipt &&
                              errors.deliveryReceipt && (
                                <div className="error-message">
                                  <img src={ErrorIcon} alt="error icon" />
                                  <span className="text-danger">
                                    {errors.deliveryReceipt}
                                  </span>
                                </div>
                              )}
                          </div>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col md="4" order={2} className="mainBgColor">
            <div className="sticky-tarif-wrapper">
              {triggerRender ? (
                <>
                  <h4 className="pt-5 title-style">Tarif</h4>
                  <Card className="mb-3 cardDemandeFo">
                    <Card.Body>
                      <table style={{ width: "100%", fontSize: "16px" }}>
                        <tbody>
                          <tr>
                            <td><strong>Temps estimé de trajet</strong></td>
                            <td style={{ textAlign: "right" }}>
                              {typeof estimatedTime === 'number' ? `${estimatedTime} minutes`
                              : "Tarif indisponible. On revient vite par mail pour vous confirmer le prix"}
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Poids</strong></td>
                            <td style={{ textAlign: "right" }}>{poidsLabel}</td>
                          </tr>
                        </tbody>
                      </table>

                      <hr />

                      <table style={{ width: "100%", fontSize: "16px" }}>
                        <tbody>
                          <tr>
                            <td>Tarif base</td>
                            <td style={{ textAlign: "right" }}>
                              <strong>{(tarifBase + tempsSupplement).toFixed(2)} €</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>Supplément poids</td>
                            <td style={{ textAlign: "right" }}>
                              <strong>{poidsSupplement.toFixed(2)} €</strong>
                            </td>
                          </tr>
                          <tr>
                          <td>
                            Option : 
                            {livraisonType === "flex"
                              ? " Livraison Flex"
                              : livraisonType === "planifiee"
                                ? " Livraison Planifiée"
                                : " Livraison Urgente"}
                            
                          </td>
                          <td style={{ textAlign: "right" }}>
                            <strong>
                              {supplementLivraison > 0
                                ? `${supplementLivraison.toFixed(2)} €`
                                : "0,00 €"}
                            </strong>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <hr />

                      <table style={{ width: "100%", fontSize: "16px" }}>
                        <tbody>
                          <tr>
                            <td><strong>Total HT</strong></td>
                            <td style={{ textAlign: "right" }}>
                              <strong>{totalHT.toFixed(2)} €</strong>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Total TTC</strong></td>
                            <td style={{ textAlign: "right" }}>
                              <strong>{totalTTC.toFixed(2)} €</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <hr />
                      <div className="mt-3 text-center text-muted small">
                        Marion se réserve le droit de modifier le prix selon le poids réel de la livraison
                      </div>

                      <div className="d-grid mt-3 text-center">
                          {ctaErrorMessage && (
                            <div className="cta-error-message">
                              ❗ {ctaErrorMessage}
                            </div>
                          )}

                          <button
                            type="submit"
                            form="formikForm"
                            className={`btn btn-success ${ctaErrorShake ? "shake-button error-cta" : ""}`}
                            disabled={!triggerRender|| isSubmittingLocal|| (formikRef.current?.values?.deliveryReceipt && (!pdfAnalyzed || isPdfChecking))}
                            onClick={(e) => {
                              const values = formikRef.current?.values || {};
                              touchAllFields(values); // 👈 Fonction déclarée plus haut
                              const errors = formikRef.current?.errors || {};
                              const errorCount = Object.keys(errors).length;

                              if (errorCount > 0) {
                                e.preventDefault();
                                setNbTentativesSubmit((prev) => prev + 1); // 📊 Tracker tentative échouée
                                trackFormAbandonment('erreurs_validation', errors); // 📊 Envoyer le tracking
                                setCtaErrorMessage(`Veuillez corriger les ${errorCount} erreur${errorCount > 1 ? "s" : ""}`);
                                setCtaErrorShake(true);
                                setTimeout(() => {
                                  setCtaErrorShake(false);
                                  setCtaErrorMessage("");
                                }, 3000);
                              }
                            }}
                          >
                            {isSubmittingLocal ? "Envoi en cours..." : "Valider la demande"}
                          </button>
                        </div>

                    </Card.Body>
                  </Card>
                </>
              ) : (
                <Card className="mb-3 cardDemandeFo">
                  <Card.Body className="bg-light-yellow">
                    <p style={{ fontSize: "16px", marginBottom: "16px" }}>
                      Pour obtenir un prix, veuillez renseigner <strong>l’adresse de ramassage</strong>, <strong>l’adresse de livraison</strong>, <strong>le poids</strong> et <strong>le type de livraison</strong>.
                      <br />
                      Les autres champs sont obligatoires pour envoyer votre demande (sauf le champ commentaire qui est facultatif).
                    </p>
                  </Card.Body>
                </Card>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FormSupplier;
